import * as React from "react";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import { Facebook, Instagram, Twitter, LinkedIn } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  FormControlLabel,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import {
  ShoppingPortalDto,
  ShoppingPortalSetting,
} from "../../../models/features/ShoppingPortal/ShoppingPortalDto";
import { useEffect, useState } from "react";
import { DmsLocations } from "../../../models/auth/Auth";
import { ErrorMessage, Form, Formik } from "formik";
import {
  PortalCreateCustomer,
  PortalSignupValidationSchema,
  portalSignupDefault,
} from "../../../models/features/Customer/PortalLogin";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux/reducer/rootReducer";
import { useDispatch } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
import { PortalCreateCustomerApi } from "../../../redux/reducer/features/Auth/authSlice";

interface PortalSignupFormProps {}
export const PortalSignupForm: React.FunctionComponent<
  PortalSignupFormProps
> = (props) => {
  const { portalSettings } = useSelector(
    (state: AppState) => state.shoppingPortalReducer
  );
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>();
  const dispatch = useDispatch<Dispatch<any>>();

  const onLoginComplete = () => {
    setIsLoading(false);
  };
  const onError = (errorMsg: string) => {
    setIsLoading(false);
    setError(errorMsg);
  };

  const handleOnSubmit = (values: PortalCreateCustomer) => {
    setError(undefined);
    setIsLoading(true);
    dispatch(
      PortalCreateCustomerApi(
        { ...values, dmsSetupId: portalSettings?.setting.dmsSetupId ?? "" },
        onLoginComplete,
        onError
      )
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography component="h1" variant="h5">
        Sign up
      </Typography>
      <Formik
        initialValues={portalSignupDefault}
        validationSchema={PortalSignupValidationSchema}
        onSubmit={(values) => {
          handleOnSubmit(values);
        }}
      >
        {({ values, errors, handleChange, handleBlur }) => (
          <>
            <Form>
              <Grid container spacing={2} alignItems="center" mt={1}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="First Name"
                    size="small"
                    name="firstName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.firstName}
                    autoComplete="firstName"
                  />
                  <ErrorMessage
                    className="error-msg"
                    component={"div"}
                    name="firstName"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Last Name"
                    size="small"
                    name="lastName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.lastName}
                    autoComplete="lastName"
                  />
                  <ErrorMessage
                    className="error-msg"
                    component={"div"}
                    name="lastName"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Phone"
                    size="small"
                    name="phone"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phone}
                    autoComplete="phone"
                  />
                  <ErrorMessage
                    className="error-msg"
                    component={"div"}
                    name="phone"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Email"
                    size="small"
                    name="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    autoComplete="email"
                  />
                  <ErrorMessage
                    className="error-msg"
                    component={"div"}
                    name="email"
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Password"
                    size="small"
                    name="password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    type="password"
                  />
                  <ErrorMessage
                    className="error-msg"
                    component={"div"}
                    name="password"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox value="allowExtraEmails" color="primary" />
                    }
                    label="I want to receive inspiration, marketing promotions and updates via email."
                  />
                </Grid>
                <Grid item xs={12}>
                  {error && <Alert severity="error">{error}</Alert>}
                </Grid>
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mb: 2 }}
                    disabled={isLoading}
                    startIcon={
                      isLoading ? (
                        <CircularProgress size="1.2rem" color="inherit" />
                      ) : (
                        ""
                      )
                    }
                  >
                    Sign up
                  </Button>
                </Grid>
              </Grid>
            </Form>
          </>
        )}
      </Formik>
    </Box>
  );
};
